import React from "react";
import styled from "styled-components";
import FormTitle from "../atoms/FormTitle";
import ExplanationText from "../atoms/ExplanationText";
import ContentContainer from "../atoms/ContentContainer";
import InputItem from "../atoms/InputItem";
import InputWrapper from "../atoms/InputWrapper";
import InputItemWrapper from "../atoms/InputItemWrapper";
import ChevronRight from "../atoms/icons/ChevronRight";
import { firstError } from "../../Services/Form";
import FlashMessage from "../molecules/FlashMessage";
const StyledInputWrapper = styled(InputWrapper) `
    display: flex;
    justify-content: space-between;
`;
const OpenInformationRequest = ({ loading, errors, credentials, onSubmit: handleSubmit, onChange: handleChange, }) => {
    return (React.createElement("form", { onSubmit: handleSubmit },
        React.createElement(ContentContainer, { loading: loading, hasMandatoryExplanationText: true, hasFooterActions: true, hasNextButtonIconRight: true, buttonFullWidth: true, nextButtonIcon: React.createElement(ChevronRight, null), nextButtonText: "Informatie aanvullen" },
            React.createElement(FormTitle, null, "Informatieverzoek openen"),
            React.createElement(FlashMessage, null),
            React.createElement(ExplanationText, null, "Voer alstublieft het dossiernummer, lettercode en verzoekcode in die u van ons heeft ontvangen. Deze gegevens staan vermeld in de brief die u van ons heeft ontvangen."),
            React.createElement(InputWrapper, null,
                React.createElement(InputItem, { disabled: loading, error: firstError(errors.debtor_number) ||
                        firstError(errors.dossier_number), onChange: handleChange, value: credentials.dossier_number, name: "dossier_number", type: "text", label: "Dossiernummer", isMandatory: true })),
            React.createElement(StyledInputWrapper, null,
                React.createElement(InputItemWrapper, null,
                    React.createElement(InputItem, { disabled: loading, error: firstError(errors.form_code), onChange: handleChange, value: credentials.form_code, name: "form_code", type: "text", label: "Lettercode", isMandatory: true, fullWidth: true })),
                React.createElement(InputItemWrapper, null,
                    React.createElement(InputItem, { disabled: loading, error: firstError(errors.employer_number), onChange: handleChange, value: credentials.employer_number, name: "employer_number", type: "text", label: "Verzoekcode", isMandatory: true, fullWidth: true }))))));
};
export default OpenInformationRequest;
